import React from "react";
import Modal from "../../../../components/ModalPopup";
import Button from "../../../../components/Button";
import { IMDM_ORG_NAME } from "../../../../utils/constants";
import { Formik, Field } from "formik";
import {
  action_list,
  reason_list
} from "../../../../utils/idenitySpecNotesConfigs";
import * as Yup from "yup";
import DropDownList from "../../../../components/DropDownList";
import Label from "../../../../components/Label";
import TextBox from "../../../../components/TextBox";
import ButtonList from "../../../../components/ButtonList";
import { useAuthState } from "../../../../components/AuthProvider";

import styles from "./ConfirmationDialog.module.scss";
import Flex from "../../../../components/Flex";

const ConfirmationDialog = ({
  confirmationDailog,
  setConfirmationDialog,
  actionCounts,
  bulkStewardHandler
}) => {
  const { user } = useAuthState();
  return (
    <div className={styles.base}>
      <Modal
        open={confirmationDailog}
        onClose={() => setConfirmationDialog(false)}
      >
        {actionCounts.selectedPrimaryRecords === 0 ? (
          <div>
            <div>
              Please include at least one record from the primary identity to
              start Including/Excluding records.
            </div>
            <br />
            <div>
              <Button primary onClick={() => setConfirmationDialog(false)}>
                OK
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <div>
              <p>Are you sure you would like to Include/Exclude the selected</p>
              <p>records to this Focus Identity? </p>
              <br />
              <p>These changes will be reflected in the Focus Identity </p>
              <p>record partitioning.</p>
            </div>

            <br />
            {user.preferences.selectedClient.organization.name ===
              IMDM_ORG_NAME ||
            user.preferences.selectedClient.organization.name === "IMDM" ? (
              <Formik
                initialValues={{
                  action: "",
                  reason: "",
                  comments: "",
                  isSkipRepartitionRequest: false
                }}
                onSubmit={bulkStewardHandler}
                validateOnChange={false}
                validationSchema={Yup.object().shape({
                  action: Yup.string().required("Action is  Required"),
                  reason: Yup.string().required("Reason Required")
                })}
              >
                {({ errors, handleChange, handleSubmit, values }) => (
                  <form onSubmit={handleSubmit} className={styles.form}>
                    <section>
                      <div>
                        <DropDownList
                          className={styles.inputFields}
                          errorText={errors.action}
                          id="action"
                          onChange={handleChange}
                          label={
                            <Label
                              error={Boolean(errors.action)}
                              htmlFor="action"
                            >
                              <b>Action</b>
                            </Label>
                          }
                          value={values.action}
                          required
                        >
                          <DropDownList.Item value="">
                            Select Action
                          </DropDownList.Item>
                          {action_list.map(action => (
                            <DropDownList.Item key={action} value={action}>
                              {action}
                            </DropDownList.Item>
                          ))}
                        </DropDownList>
                      </div>
                      <div>
                        <DropDownList
                          className={styles.inputFields}
                          errorText={errors.reason}
                          id="reason"
                          onChange={handleChange}
                          label={
                            <Label
                              error={Boolean(errors.reason)}
                              htmlFor="reason"
                            >
                              <b>Reason</b>
                            </Label>
                          }
                          value={values.reason}
                          required
                        >
                          <DropDownList.Item value="">
                            Select Reason
                          </DropDownList.Item>
                          {reason_list.map(reason => (
                            <DropDownList.Item key={reason} value={reason}>
                              {reason}
                            </DropDownList.Item>
                          ))}
                        </DropDownList>
                      </div>
                      <div>
                        <TextBox
                          className={styles.inputFields}
                          errorText={errors.comments}
                          id="comments"
                          label={
                            <Label
                              error={Boolean(errors.comments)}
                              htmlFor="comments"
                            >
                              <b>Comments</b>
                            </Label>
                          }
                          onChange={handleChange}
                          value={values.comments}
                        />
                      </div>
                    </section>
                    <div role="isSkipRepartitionCheckBox">
                      <label for="isSkipRepartitionCheckBox">
                        <Field
                          type="checkbox"
                          name="isSkipRepartitionRequest"
                        />{" "}
                        <b> (Optional) Skip Repartitioning </b> <br /> Ignore
                        how records match each other and only move records as
                        necessary to honor the includes and excludes. Matching
                        is only performed to find a new home for records that
                        have to be moved out. This can avoid timeouts by doing
                        less matching.
                      </label>
                      <br />
                      <br />
                    </div>
                    <ButtonList className={styles.center}>
                      <Button type="submit" primary>
                        Confirm
                      </Button>
                      <Button onClick={() => setConfirmationDialog(false)}>
                        Cancel
                      </Button>
                    </ButtonList>
                  </form>
                )}
              </Formik>
            ) : (
              <ButtonList className={styles.center}>
                <Button
                  type="submit"
                  primary
                  onClick={() => {
                    bulkStewardHandler("", "", "");
                  }}
                >
                  Confirm
                </Button>
                <Button onClick={() => setConfirmationDialog(false)}>
                  Cancel
                </Button>
              </ButtonList>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ConfirmationDialog;
